import React, { useState, useEffect, useRef } from "react";
import "./Page.css";
import { useNavigate, useLocation } from 'react-router-dom';
import VideoPage from "../LandingFolder/VideoSection";
import { BASE_URL, get } from "../../services/Calls";


import BlackEnvelopeIcon from "../../assets/blackEnvelopeIcon.png"
import FbBlackIcon from "../../assets/fbBlackIcon.png"
import BlackWhatsappIcon from "../../assets/blackWhatsappIcon.png"

import GallerySection from "../Destinations/GallerySection";
import Header from "../../GeneralComponents/Header";
import Footer from "../../GeneralComponents/Footer";
import LocalExpert from "../LandingFolder/LocalExpert";

import ImgNotFound from "../../teamImages/ImgNotFound.png"
import OmerFlum from "../../teamImages/omer-flum.jpg"
import OMERBRIKMAN from "../../teamImages/OMER-BRIKMAN.jpg"
import TSACHIGLOBIN from "../../teamImages/TSACHI-GLOBIN.jpg"


import GALFLUM from "../../teamImages/GAL-FLUM.jpg"
import DUDISHILLER from "../../teamImages/DUDI-SHILLER.jpg"
import MENACHEMBEN from "../../teamImages/MENACHEM-BEN.jpg"
import SHIRASITTON from "../../teamImages/SHIRA-SITTON.jpg"
import ShakedGlobin from "../../teamImages/Shaked-Globin.jpg"
import EyalFlum from "../../teamImages/Eyal-Flum.jpg"




const OurTeam = () => {

  const navigate = useNavigate();
  const location = useLocation();


  const [localHeroes, setLocalHeroes] = useState<any[]>([]);


  const teamMembers = [

    {
      name: "Omer Flum",
      role: "CEO",
      /* role: "The leading force behind PlanYourTrip", */
      image: OmerFlum,
    },
    {
      name: "Omer Brickman",
      role: "COO",
      /*  role: "The leading force behind PlanYourTrip", */
      image: OMERBRIKMAN,
    },
    {
      name: "Tsachi Globin ",
      role: "Chief guide",
      /*  role: "Our Chief Trip Planning Officer", */
      image: TSACHIGLOBIN,
    },

    {
      name: "Orna Oren",
      role: "CFO",
      /*  role: "Our Chief Trip Planning Officer", */
      image: ImgNotFound,
    }
  ]




  //Travel consultant
  const travelConsultant = [
    {
      name: "Gal Flum",
      role: "Travel consultant",
      image: GALFLUM,
    },
    {
      name: "Dudi Shiler ",
      role: "Travel consultant",
      image: DUDISHILLER,
    },
    {
      name: "Menachem b.",
      role: "Travel consultant",
      image: MENACHEMBEN,
    },
    {
      name: "Shira Sitton",
      role: "Tour operator",
      image: SHIRASITTON,
    },
    {
      name: "Eliya Weiss ",
      role: "Tour operator",
      image: ImgNotFound,
    },
    {
      name: "Shaked Globin",
      role: "Tour operator",
      image: ShakedGlobin,
    },
    {
      name: "Eyal",
      role: "Digital Marketing",
      image: EyalFlum,
    },

  ];


  useEffect(() => {
    getLocalExpertData();
  }, []);


  const getLocalExpertData = async () => {
    try {
      const response = await get(BASE_URL + `/local-experts`);
      if (response?.data?.length > 0) {
        console.log('localhero',response.data)
        setLocalHeroes(response.data);
      }
    } catch (error) {
      console.error("Error fetching local experts:", error);
    }
  };
  return (
    <div>
      <Header />
      <VideoPage pageFrom={'OurTeam'} countryname={""} />
      <div className="destinationPathRow" id="OurTeamPageId">
        <div className="destinationPaginationDiv">
          <span className="destinationPaginationHome" onClick={() => { navigate('/') }} >Home</span>
          <span className="destinationPaginationBorder"></span>
          <span className="destinationPaginationCountry">Our Team</span>
        </div>
        <div className="destinationSocialIconDiv">
          <a href="https://www.facebook.com/profile.php?id=61576034056586" target="_blank" >
            <img className="destinationSocialFbIcon" src={FbBlackIcon} /></a>

          <a href="mailto:info@medraft.co.il"><img className="destinationSocialMailIcon" src={BlackEnvelopeIcon} /></a>
          <a href="https://wa.me/9720542927253" target="_blank" rel="noopener  noreferrer" > <img className="destinationSocialWhatsAppIcon" src={BlackWhatsappIcon} /></a>
        </div>
      </div>

      <div className="mainComponent" style={{ width: 'auto' }}>

        <div className="team-container">
          <h2 className="team-title">Our Team</h2>
          <div className="team-grid">
            {teamMembers.map((member, index) => (
              <div key={index} className="team-card">
                <img src={member.image} alt={member.name} className="team-image" />
                <h3 className="team-name">{member.name}</h3>
                <p className="team-role">{member.role}</p>
              </div>
            ))}

          {/* </div>
          <div className="team-grid" style={{marginTop:40}}> */}

            {localHeroes.map((member, index) => (
              <div key={index} className="team-card">
                <img src={member.imageURL} alt={member.name} className="team-image" />
                <h3 className="team-name">{member.name}</h3>
                <p className="team-role">{member.country.name} Expert</p>
              </div>
            ))}
          {/* </div>
          <div className="team-grid" style={{marginTop:40}}> */}
            {travelConsultant.map((member, index) => (
              <div key={index} className="team-card">
                <img src={member.image} alt={member.name} className="team-image" />
                <h3 className="team-name">{member.name}</h3>
                <p className="team-role">{member.role}</p>
              </div>
            ))}

          </div>
        </div>
      </div>



      {/*  <GallerySection /> */}
      {/*  <div style={{ height: '6.625vw' }}></div> */}
      <Footer />
    </div>
  )
}
export default OurTeam;
